import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Busqueda } from 'src/app/interfaces/candidatos';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CandidatosService {

    private baseApUrl = environment.baseApi + '/publico/candidatos';
    private baseApUrl2 = environment.baseApi + '/publico/inicio';
    constructor(private httpClient: HttpClient) { }

    async obtenerCandidatos(salario: number):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/filtro/${salario}`).toPromise();
    }

    async obtenerCandidatosExperiencia(tiempoExperiencia: number):Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/experiencia/${tiempoExperiencia}`).toPromise();
    }

    async obtenerCandidatosNuevos():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/candidato-nuevo`).toPromise();
    }

    async obtenerCandidatosDestacados():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl2}/candidatos-destacados`).toPromise();
    }

    async obtenerCandidatosPalabraClave(buscador: Busqueda):Promise<any>{
        let params = new HttpParams();
        if(buscador.palabra != null){
            params = params.set("palabra", buscador.palabra);
        }
        if(buscador.pais != null){
            params = params.set("pais", buscador.pais);
        }
        return await this.httpClient.get<any>(
            `${this.baseApUrl}/candidato-busqueda/${buscador.idCategoria}`,
            {params}
        ).toPromise();
    }

    async obtenerEstados():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApUrl}/estados`).toPromise();
    }
}
